import { useStore } from '@nanostores/react';
import { useCallback, useRef, useState } from 'react';
import { GithubConflictDialog } from '~/components/github/GithubConflictDialog';
import { useGithubStore } from '~/lib/context/github';
import { withResolvers } from '~/utils/promises';

export function useGithubConflict() {
  const [conflict, setConflict] = useState(false);
  const conflictRef = useRef<PromiseWithResolvers<boolean>>(null as any);

  const store = useGithubStore();
  const target = useStore(store.target);

  const show = useCallback(() => {
    setConflict(true);
    conflictRef.current = withResolvers();

    return conflictRef.current.promise;
  }, [setConflict]);

  function fix(tryAgain: boolean) {
    setConflict(false);

    conflictRef.current.resolve(tryAgain);
  }

  const dialog = conflict && target && <GithubConflictDialog repo={target.repository} open onClose={fix} />;

  return {
    show,
    dialog,
  };
}
